module.exports = __webpack_public_path__ + "assets/img/pays.b8087556.png";